/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationResponse } from './OrganizationResponse';
import {
    OrganizationResponseFromJSON,
    OrganizationResponseFromJSONTyped,
    OrganizationResponseToJSON,
    OrganizationResponseToJSONTyped,
} from './OrganizationResponse';
import type { UserMigrationQueryApplicationResponse } from './UserMigrationQueryApplicationResponse';
import {
    UserMigrationQueryApplicationResponseFromJSON,
    UserMigrationQueryApplicationResponseFromJSONTyped,
    UserMigrationQueryApplicationResponseToJSON,
    UserMigrationQueryApplicationResponseToJSONTyped,
} from './UserMigrationQueryApplicationResponse';
import type { UserMigrationQueryPermissionResponse } from './UserMigrationQueryPermissionResponse';
import {
    UserMigrationQueryPermissionResponseFromJSON,
    UserMigrationQueryPermissionResponseFromJSONTyped,
    UserMigrationQueryPermissionResponseToJSON,
    UserMigrationQueryPermissionResponseToJSONTyped,
} from './UserMigrationQueryPermissionResponse';
import type { UserMigrationQueryRoleResponse } from './UserMigrationQueryRoleResponse';
import {
    UserMigrationQueryRoleResponseFromJSON,
    UserMigrationQueryRoleResponseFromJSONTyped,
    UserMigrationQueryRoleResponseToJSON,
    UserMigrationQueryRoleResponseToJSONTyped,
} from './UserMigrationQueryRoleResponse';

/**
 * 
 * @export
 * @interface UserMigrationQueryResponse
 */
export interface UserMigrationQueryResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserMigrationQueryResponse
     */
    requireUserInput?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryResponse
     */
    username?: string | null;
    /**
     * 
     * @type {UserMigrationQueryApplicationResponse}
     * @memberof UserMigrationQueryResponse
     */
    application?: UserMigrationQueryApplicationResponse;
    /**
     * 
     * @type {UserMigrationQueryRoleResponse}
     * @memberof UserMigrationQueryResponse
     */
    role?: UserMigrationQueryRoleResponse;
    /**
     * 
     * @type {UserMigrationQueryPermissionResponse}
     * @memberof UserMigrationQueryResponse
     */
    permission?: UserMigrationQueryPermissionResponse;
    /**
     * 
     * @type {OrganizationResponse}
     * @memberof UserMigrationQueryResponse
     */
    organization?: OrganizationResponse;
}

/**
 * Check if a given object implements the UserMigrationQueryResponse interface.
 */
export function instanceOfUserMigrationQueryResponse(value: object): value is UserMigrationQueryResponse {
    return true;
}

export function UserMigrationQueryResponseFromJSON(json: any): UserMigrationQueryResponse {
    return UserMigrationQueryResponseFromJSONTyped(json, false);
}

export function UserMigrationQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationQueryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'requireUserInput': json['requireUserInput'] == null ? undefined : json['requireUserInput'],
        'username': json['username'] === undefined ? undefined : json['username'] === null ? null : json['username'],
        'application': json['application'] == null ? undefined : UserMigrationQueryApplicationResponseFromJSON(json['application']),
        'role': json['role'] == null ? undefined : UserMigrationQueryRoleResponseFromJSON(json['role']),
        'permission': json['permission'] == null ? undefined : UserMigrationQueryPermissionResponseFromJSON(json['permission']),
        'organization': json['organization'] == null ? undefined : OrganizationResponseFromJSON(json['organization']),
    };
}

export function UserMigrationQueryResponseToJSON(json: any): UserMigrationQueryResponse {
    return UserMigrationQueryResponseToJSONTyped(json, false);
}

export function UserMigrationQueryResponseToJSONTyped(value?: UserMigrationQueryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requireUserInput': value['requireUserInput'],
        'username': value['username'],
        'application': UserMigrationQueryApplicationResponseToJSON(value['application']),
        'role': UserMigrationQueryRoleResponseToJSON(value['role']),
        'permission': UserMigrationQueryPermissionResponseToJSON(value['permission']),
        'organization': OrganizationResponseToJSON(value['organization']),
    };
}

